import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/land-monitoring/$propertyId/payment')({
  validateSearch: (search: Record<string, unknown>) => {
    const status = search.status;
    return {
      status: status === 'success' || status === 'cancelled' ? status : undefined,
    };
  },
});
